import moment from 'moment'
import { Expose, Transform, Type } from 'class-transformer'
import { Truck } from 'react-feather'

import { ASN } from './ASN'

export class Transload {
  static type = 'transload'
  static typeDisplay = 'Transload'
  static icon = Truck

  type = Transload.type
  typeDisplay = Transload.typeDisplay
  icon = ASN.icon

  @Expose({ name: 'xid' })
  guid: string = ''

  get name() {
    return `Transload for ${this.asn?.name}`
  }

  @Type(() => ASN)
  asn?: ASN

  @Expose({ name: 'created_on' })
  @Transform((value) => moment(value))
  createdOn: moment.Moment = moment()

  @Expose({ name: 'updated_on' })
  @Transform((value) => moment(value))
  updatedOn: moment.Moment = moment()
}
